// Template Generated by DataExtraction.py at 1716936483
        
import TemproarySinEn1 from "../../Forms/Temporary SIN/TemproarySin_En1.png";
import TemproarySinEn1Labels from "../../Labels/Temporary SIN/TemproarySin_En1.json";
import TemproarySinFr1 from "../../Forms/Temporary SIN/TemproarySin_Fr1.png";
import TemproarySinFr1Labels from "../../Labels/Temporary SIN/TemproarySin_Fr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TemproarySinFr1Labels : TemproarySinEn1Labels;
    const formImage = isFrench ? TemproarySinFr1 : TemproarySinEn1;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;

    let subNames = "";

    if (subscriber.lastName) {
        subNames += subscriber.firstName + " " + subscriber.lastName;
    }

    if (common.subscriber2Include && jointSubscriber.lastName) {
        subNames += ", " + jointSubscriber.firstName + " " + jointSubscriber.lastName;
    }

    const now = moment(new Date()).format("YYYY-MM-DD");


    // Drawing the form
    drawText(common.agentName, "drName");
    drawText(now, "signDate");
    drawText(subNames, "subNames");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? TemproarySinFr1Labels : TemproarySinEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    
    
    // drSignature
    signers.push({
        [subscriberRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("s1SignatureView", labels))],
    });

    if (state.common.subscriber2Include) {
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s2SignatureView", labels))],
        });
    }

    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    